import { Injectable, signal } from '@angular/core';

/**
 * App-wide "what do we call a Site" setting (Site / Branch / Department / Location),
 * configured once in Settings → Organization and consumed by any module (Help Desk, etc.)
 * that shows a Site field, instead of each module keeping its own copy.
 */
@Injectable({ providedIn: 'root' })
export class SiteTerminologyService {
  private readonly STORAGE_KEY = 'sw_site_field_label';

  readonly options = ['Site', 'Branch', 'Department', 'Location'];

  readonly siteLabel = signal<string>(this.load());

  private load(): string {
    try {
      return localStorage.getItem(this.STORAGE_KEY) || 'Site';
    } catch {
      return 'Site';
    }
  }

  setSiteLabel(label: string) {
    const value = label || 'Site';
    this.siteLabel.set(value);
    try {
      localStorage.setItem(this.STORAGE_KEY, value);
    } catch { /* storage unavailable */ }
  }
}
